<div class="flex h-screen items-center justify-center">
	<div class="w-85 space-y-5 rounded bg-white p-6 drop-shadow-md">
		<img ngSrc="/images/logo_round_small.png" alt="Somerville Logo" height="35" class="mx-auto mb-4" width="35" />
		<h1 class="text-center text-lg font-medium text-gray-700">Somerville Requisitions</h1>
		<app-sign-in-form></app-sign-in-form>
	</div>
</div>
